import { ClientOnly } from "@/components/Base/ClientOnly";
import Icon from "@/components/Icon";
import { useNavigate } from "@solidjs/router";

export enum TitlePosition {
  LEFT = "left",
  CENTER = "center",
}
export default function PageNav(props: {
  close?: () => void;
  title: string;
  titlePosition?: TitlePosition;
}) {
  const navigate = useNavigate();
  return (
    <div class="sticky top-0 z-[1000] flex h-[48px] w-full items-center bg-[var(--colors-surface-bg-8)] px-[12px] font-['Alexandria']">
      <ClientOnly>
        <div class="bg-linear-180 size-7 rounded-[7px] from-[var(--colors-border-icon-top5)] to-[var(--colors-border-icon-bottom10)] p-[1px] shadow-[0_3.5px_9.363px_0_rgba(0,0,0,0.25)]">
          <Icon
            name="general/longarrow-left"
            class="text-general-white size-[14px]"
            wrapperClass="!rounded-[7px] w-full h-full bg-linear-180 from-[var(--colors-surface-bg-7)] to-[var(--colors-surface-bg-6)]"
            onClick={() => {
              if (props.close) {
                props.close();
              } else {
                navigate(-1);
              }
            }}
          />
        </div>
      </ClientOnly>
      <h1
        class={`max-w-[calc(100%-104px)] text-[16px] font-bold text-[var(--colors-text-primary)] ${props.titlePosition == TitlePosition.LEFT ? "ml-[10px]" : "absolute left-1/2 translate-x-[-50%]"} w-[max-content]`}
      >
        {props.title}
      </h1>
    </div>
  );
}
